import { db } from '@/plugins/firebase';
import { EXCLUDED_USERS_LIST } from '@/consts/global';
import { getPurchaseHistoryByLiveId, PURCHASE_KIND, TYPE } from '@/services/doronServices';
import * as userServices from '@/services/userServices';
import * as DateTime from '@/utils/date';

const liveReport_collectionName = "liveReport";

export async function createLiveReport(liveId) {
  await updateLiveReportDoc(
    liveId,
    await convertSummary(await getPurchaseHistory(liveId))
  );
}

async function getPurchaseHistory(liveId) {
  let resultList = {};

  for (let key in PURCHASE_KIND) {
    resultList[PURCHASE_KIND[key]] = [];
  }

  const list = await getPurchaseHistoryByLiveId(liveId);

  for (let data of list) {
    if (EXCLUDED_USERS_LIST.includes(data.userId)) continue;
    if (!(data.purchaseKind in resultList)) continue;
    resultList[data.purchaseKind].push({
      'updatedAt' : DateTime.fromUnixToJSDate(data.updatedAt.seconds),
      'userId': data.userId,
      'castId': data.castId,
      'amount': data.amount,
      'type': data.type
    });
  }

  for (let key in resultList) {
    resultList[key].sort((item1, item2) => { return item1.updatedAt - item2.updatedAt; });
  }

  return resultList;
}

async function convertSummary(purchaseHistory) {
  let userList = {};

  let summary = {};
  for (let key in purchaseHistory) {
    summary[`amount_${key}`] = 0;
    summary[`paidAmount_${key}`] = 0;
    summary[`freeAmount_${key}`] = 0;
    summary[`details_${key}`] = [];
  }
  
  for (let key in purchaseHistory) {
    if (purchaseHistory[key].length < 1) continue;

    let firstElem = purchaseHistory[key][0];

    if (!summary.updatedAt) {
      if (!(firstElem.castId in userList)) {
        userList[firstElem.castId] = await userServices.getUserDoc(firstElem.castId);
      }
      var cast = userList[firstElem.castId];
      summary.updatedAt = DateTime.formatJSDate('yyyyMMdd', firstElem.updatedAt);
      summary.castId = firstElem.castId;
      summary.castName = cast.nickname;
    }

    let paidAmount = 0;
    let freeAmount = 0;

    for (let elem of purchaseHistory[key]) {
      if (elem.type == TYPE.PAID) {
        paidAmount += elem.amount;
      } else if (elem.type == TYPE.FREE) {
        freeAmount += elem.amount;
      }
    }

    summary[`amount_${key}`] = freeAmount + paidAmount;
    summary[`paidAmount_${key}`] = paidAmount;
    summary[`freeAmount_${key}`] = freeAmount;
    summary[`details_${key}`] = purchaseHistory[key];
  }

  return summary;
}

async function updateLiveReportDoc(liveId, data) {
  let success = true;
  const docRef = await db.collection(liveReport_collectionName).doc(liveId);
  await docRef
    .set(data)
    .catch(err => {
      console.error(err);
      success = false;
    });

  if (!success) return;

  const doc = await docRef.get();
  return doc.data();
}
